import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import CompanySettingsCard from './CompanySettingsCard';
import DisplayText from '../common/text/DisplayText';
import OnTraccrButton from '../common/buttons/OnTraccrButton';

import Permissions from '../auth/Permissions';
import Colors from '../constants/Colors';

const OWNER_FLAVOUR_TEXT = 'Highest level of access for the company account, including billing management and account deactivation priviliges';

function OwnerView({
  ownerId,
  onTransfer,
}) {
  const users = useSelector((state) => state.users.users);
  const owner = useMemo(() => users.find((user) => user.id === ownerId), [users, ownerId]);
  const ownerName = owner?.name ?? '';

  return (
    <CompanySettingsCard title="Account" style={{ paddingRight: 56 }}>
      <Row style={{ minHeight: 32, marginTop: 10, width: '100%' }} justify="space-between" align="middle">
        <Col>
          <DisplayText
            title="Primary Account Owner"
            style={{ fontFamily: 'roboto-medium', marginBottom: 0 }}
          />
        </Col>
        <Col>
          <DisplayText
            title={ownerName}
            style={{
              fontFamily: 'roboto-light',
              marginBottom: 0,
              marginRight: 56,
            }}
          />
        </Col>
      </Row>
      <DisplayText
        title={OWNER_FLAVOUR_TEXT}
        style={{
          fontFamily: 'roboto-light',
          marginBottom: 0,
          maxWidth: 275,
        }}
      />
      <Row style={{ width: '100%' }} justify="center">
        <OnTraccrButton
          title="Transfer Ownership"
          type={Permissions.id === ownerId ? 'primary' : 'back'}
          disabled={Permissions.id !== ownerId}
          style={{ margin: 10 }}
          onClick={onTransfer}
        />
        <DisplayText
          style={{
            textAlign: 'center',
            fontFamily: 'roboto-bold',
            color: Colors.ONTRACCR_OPACITY_GRAY,
            height: 32,
          }}
          title="Only the account owner can transfer ownership"
        />
      </Row>
    </CompanySettingsCard>
  );
}

OwnerView.propTypes = {
  ownerId: PropTypes.string.isRequired,
  onTransfer: PropTypes.func.isRequired,
};

export default OwnerView;
